export const getFormInput = (state) => state.form.input;
export const getParsedSchema = (state) => state.schema.parsedSchema.schema;
